<template>
  <v-row class="only-print" justify="center">
    <v-col cols="4" class="only-print">
      <img style="width: 100%;" class="only-print" :src="logo">
    </v-col>
  </v-row>
</template>

<script lang="ts" setup>
import logo from '@/assets/images/logo_black.png'
</script>
